<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="program-assign-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <div class="program-assign-form-body">
        <v-toolbar flat height="76">
          <v-toolbar-title class="program-assign-toolbar-title"
            >Assign program</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn color="accent" icon tile @click="closeDialog">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="new-practice-card-container pt-0">
          <bh-select
            class="mb-3"
            label="Program to assign"
            v-model="program"
            :items="availablePrograms"
            :item-text="'name'"
            :item-value="'id'"
            solo
            background-color="#ffffff"
            @input="onSelectInput"
          />
        </v-container>
      </div>
      <div class="program-assign-footer">
        <v-container class="new-practice-card-container pt-0 pb-4">
          <v-row>
            <v-col>
              <v-btn
                :disabled="!formIsValidCheck"
                elevation="0"
                rounded
                color="accent"
                @click="assignProgram"
                >Assign</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import BhSelect from '@/components/inputs/BhSelect.vue'
import RouterMixin from '@/mixins/router'
import { debounce } from '@/helpers/debounce'

export default {
  name: 'ProgramAssignDialog',
  components: {
    BhSelect,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [RouterMixin],
  data() {
    return {
      dialog: false,
      headers: [],
      selectedParticipants: [],
      routineStartDate: false,
      program: null,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  computed: {
    ...mapState('programsStates', {
      availablePrograms: 'programs',
      availableProgramsLoading: 'loading',
    }),
    ...mapState('practicesStates', [
      'practiceUser',
      'practiceUserPatients',
      'practiceUserPatientsPagination',
    ]),
    ...mapState('dictionariesStates', [
      'dictionaryPracticeUserRole',
      'dictionaryBhUsersRoleIds',
    ]),
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('userStates', ['profileId']),
    formIsValidCheck() {
      return !!this.program
    },
  },
  methods: {
    ...mapActions('practicesStates', ['getPracticeUserPatients']),
    ...mapActions('programsStates', [
      'getPrograms',
      'assignProfilesToProgram',
      'unassignProfilesFromProgram',
      'assignProgramsToPracticeParticipants',
    ]),
    getData(data = {}) {
      this.getPracticeUserPatients(data)
    },
    closeDialog() {
      this.dialog = false
      this.program = null
      this.$emit('close-dialog')
    },
    onSelectInput(val) {
      this.program = val
    },
    assignProgram() {
      this.$emit('on-submit', this.program)
      this.closeDialog()
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.program-assign {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-weight: bold;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
    background: $bh-blue--4 !important;
  }

  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
}
</style>
